<template>
  <div class="search-component">
    <process-loading ref="process" class="process"></process-loading>
    <template v-if="!reloading">
      <div style="overflow: auto"></div>
      <div class="search-result-list full" v-if="item.type !== 'InstagramUser'">
        <post-item
          :model="item"
          :key="item.mediaId"
          v-for="item in model.list"
        ></post-item>
        <div v-show="loading" class="loading-container">
          <i class="el-icon-loading"></i>
        </div>
        <div v-if="end" class="load-end">end</div>
        <div
          v-show="!loading && !end"
          class="load-more-btn"
          @click="loadMore()"
        >
          Load more
        </div>
      </div>
      <div v-if="item.type === 'InstagramUser'" class="user-container">
        <div class="user-info">
          <div
            class="user-image"
            :key="user.social_profile_picture"
            v-lazy:background-image="user.social_profile_picture"
          ></div>
          <div class="right-container">
            <div class="username">
              <div class="name">{{ user.social_username }}</div>
              <div v-show="user.social_is_verified" class="approve-icon"></div>
            </div>
            <div class="info-container">
              <div>
                <span class="num-text">{{ user.social_post_count }}</span> posts
              </div>
              <div>
                <span class="num-text">{{ user.social_follower_count }}</span>
                followers
              </div>
              <div>
                <span class="num-text">{{ user.social_following_count }}</span>
                following
              </div>
            </div>
          </div>
        </div>
        <div class="tab-list">
          <hi-tab
            v-model="tabIndex"
            :tabList="tabList"
            style="height: 28px; width: 230px"
            class="tab"
          ></hi-tab>
        </div>
        <div class="result-container">
          <div class="search-result-list people" v-show="tabIndex === 0">
            <post-item
              :model="item"
              type="profile"
              :key="item.mediaId"
              v-for="item in user.post.list"
            ></post-item>
            <div v-show="loading" class="loading-container">
              <i class="el-icon-loading"></i>
            </div>
            <div v-show="end" class="load-end">end</div>
            <div
              v-show="!loading && !end"
              class="load-more-btn"
              @click="loadMore()"
            >
              Load more
            </div>
          </div>
          <div
            class="search-result-list full people"
            :class="{ 'no-info': user.story.list.length === 0 }"
            v-show="tabIndex === 1"
          >
            <image-shade
              @click.native="itemClick(item)"
              :src="item.coverUrl"
              class="story-item"
              :key="item.mediaId"
              v-for="item in user.story.list"
            >
              <div
                class="story-item"
                :style="{ 'background-image': `url(${item.coverUrl})` }"
                :key="item.mediaId"
              >
                <div
                  v-show="item.images[0].type === 2"
                  class="video-icon"
                ></div>
              </div>
            </image-shade>
            <div v-if="user.story.list.length === 0">
              No Story in last 24 hours
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/style/theme.less";

.load-end {
  text-align: center;
  color: gray;
  font-size: 15px;
}

.load-more-btn {
  margin: 0 auto 15px auto;
  border: 1px solid #dcdfe6;
  padding: 7px 15px;
  background: white;
  font-size: 12px;
  border-radius: 3px;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 278px;
  cursor: pointer;
  :hover,
  :active {
    opacity: 0.7;
  }
}

.search-component {
  width: 100%;
  background: #fafbfc;
  display: flex;
  justify-content: center;
  position: relative;

  .process {
    top: 0;
    left: 0;
    right: 0;
    bottom: auto !important;
  }

  .user-container {
    width: 100%;
    display: flex;
    flex-direction: column;

    .user-info {
      background: white;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 30px;

      .user-image {
        width: 80px;
        height: 80px;
        background-size: contain;
        border-radius: 50%;
      }

      .right-container {
        margin-left: 25px;
        flex: 1;

        .username {
          font-size: 18px;
          font-weight: 500;
          display: flex;

          .name {
          }

          .approve-icon {
            background-image: url("../../../public/images/schedule_posts/tag_people/approve@3x.png");
            width: 18px;
            height: 18px;
            background-size: contain;
            margin-left: 14px;
            position: relative;
          }
        }

        .info-container {
          font-size: 16px;
          display: flex;
          justify-content: space-between;
          width: 340px;
          margin-top: 13px;
          .num-text {
            font-weight: 500;
          }
        }
      }
    }

    .tab-list {
      display: flex;
      align-items: center;
      background: white;
      padding-top: 10px;
      height: 38px;
      justify-content: center;
      font-weight: 500;
      border-bottom: 1px solid @border-color;
    }

    .result-container {
      flex: 1;
      display: flex;
      justify-content: center;
      overflow: auto;
    }
  }

  .search-result-list {
    width: 680px;
    padding: 20px 30px;
    flex: 1;
    &.full {
      width: 100%;
      padding: 12px 20px;
      font-size: 0;
      overflow: auto;
      height: calc(~"100vh - 130px");
    }
    &.people {
      height: calc(~"100vh - 290px");
      &.full {
        height: calc(~"100vh - 300px");
      }
    }
    &.no-info {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: rgba(140, 140, 140);
    }
    .story-item {
      width: 190px;
      height: 337px;
      background-size: cover;
      margin: 8px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;

      .video-icon {
        width: 55px;
        height: 55px;
        background-size: cover;
        position: absolute;
        background-image: url("../../../public/images/schedule_posts/list/video.png");
      }
    }

    .loading-container {
      height: 40px;
      text-align: center;
      font-size: 20px;
      line-height: 40px;
    }
  }
}
</style>

<script>
import PostItem from "./PostItem";
import { searchDetail, searchUserPost } from "../../service/instagram";
import hiTab from "../../components/common/tab/Tab";
import processLoading from "../../components/common/process/Index";
import ImageShade from "../common/media/ImageShade";
import { showErrorMsg } from "../../utils/errors";

export default {
  name: "RepostSearchResultListComponent",
  components: { ImageShade, PostItem, hiTab, processLoading },
  props: {
    type: {
      type: String,
      default: "normal", // normal 普通类型(传什么就显示什么类型) explore 只显示 explore
    },
  },
  data() {
    return {
      model: {
        list: [],
        nextId: "",
      },
      tabIndex: 0,
      tabList: [
        {
          title: "Post",
        },
        {
          title: "Story",
        },
      ],
      user: {},
      explore: {
        list: [],
        nextId: "",
      },
      item: { type: "None" },
      loading: false,
      end: false,
      reloading: false,
    };
  },
  computed: {
    current() {
      const type = this.item.type;
      let list = [];
      let nextId = null;
      if (type === "InstagramUser") {
        // 如果是用户类型则判断当前tab
        if (this.tabIndex === 0) {
          // post
          list = this.user.post.list;
          nextId = this.user.post.nextId;
        } else {
          list = this.user.story.list;
          nextId = this.user.story.nextId;
        }
      } else {
        list = this.model.list;
        nextId = this.model.nextId;
      }
      return {
        list,
        nextId,
      };
    },
  },
  methods: {
    /**
     * 重新加载(外部调用)
     */
    async reload({ item }) {
      if (item) {
        this.item = item;
      }
      try {
        if (this.$refs.process) {
          this.$refs.process.start();
        }
        this.reloading = true;
        if (this.item.type === "InstagramUser") {
          this.user = await searchDetail({ item: this.item });
          this.end = this.user.post.nextId === null;
        } else {
          this.model.list = [];
          this.model = await searchDetail({ item: this.item });
          this.end = this.model.nextId === null;
        }
      } catch (e) {
        showErrorMsg(e);
      } finally {
        if (this.$refs.process) {
          this.$refs.process.done();
        }
        this.reloading = false;
      }
      this.loadMore();
    },
    /**
     * 加载更多
     */
    async loadMore() {
      // 防止后面已经没有还点击load more
      if (this.item.type === "InstagramUser") {
        if (this.tabIndex === 0 && !this.user.post.nextId) {
          return;
        }
        if (this.tabIndex === 1) {
          return;
        }
      } else {
        if (!this.model.nextId) {
          return;
        }
      }
      this.loading = true;
      let result;
      if (this.item.type === "InstagramUser") {
        result = await searchUserPost({
          uid: this.item.id,
          nextId: this.user.post.nextId,
        });
        this.user.post.list.push(...result.list);
        this.user.post.nextId = result.nextId;
      } else {
        result = await searchDetail({
          item: this.item,
          nextId: this.model.nextId,
        });
        this.model.list.push(...result.list);
        this.model.nextId = result.nextId;
      }
      if (result.nextId === null) {
        this.end = true;
      }
      this.loading = false;
    },
    /**
     * 单项点击事件
     * @param item 选中项
     */
    itemClick(item) {
      // 是否可以切换
      item.canSwitch = true;
      this.$bus.$emit("showRepostDetail", item);
    },
    /**
     * 获取media
     * @param mediaId searchRpost索引
     * @param type 获取的类型 current 当前项 prev 前一项 next 下一项
     */
    async getCurrentInfo({ mediaId, type = "current" }) {
      // 找到对应项
      let index = this.current.list.findIndex((m) => {
        return m.mediaId === mediaId;
      });
      if (type === "prev") {
        index -= 1;
      }
      if (type === "next") {
        index += 1;
        // 如果发现已经超出缓存范围则请求下一页
        if (this.current.list.length <= index) {
          await this.loadMore();
        }
      }
      let next = true;
      const last = index === this.current.list.length - 1;
      if (!this.current.nextId && last) {
        next = false;
      }
      const result = {
        first: index === 0,
        index,
        next,
        last,
        model: this.current.list[index],
      };
      return result;
    },
  },
  mounted() {
    if (this.type === "explore") {
      this.item = {
        type: "InstagramExplore",
      };
      this.reload({});
    }
  },
};
</script>
